import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CommonService } from './common.service';
import { MessageService } from './message.service';

import { environment } from '../../environments/environment';

@Injectable()
export class EventService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private messageService: MessageService
  ) { }

  private httpOptions = this.commonService.httpOptions;
  private Options = this.commonService.Options;
  
  getEvent (param:any){
    this.commonService.loadingStart();
    return this.http.get(environment.apiUrl+'/api/event/event_all/'+ param.publish_mode + '/'+ param.page + '/'  + param.display_per_page,this.httpOptions)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('event_all', []))
      );
  }

  save (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/event/save',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('saveEvent', []))
      );
  }
  delete (param:any){
    this.commonService.loadingStart();
    return this.http.post(environment.apiUrl+'/api/event/delete',param,this.Options)
      .pipe(
        tap(Response => this.commonService.loadingEnd()),
        catchError(this.commonService.handleError('deleteEvent', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/event.service.ts